const officeInfo = {
    address: "7218 Masters, Manvel, TX 77578",
    phone: "(281) 519-7006",
    email: "management"+"."+"updentalofmanvel"+"@"+"gmail"+"."+"com",
    schedule : [
        { day: 'Monday', day_short: 'MO', hours: '2:00 PM - 10:00 PM' },
        { day: 'Tuesday', day_short: 'TU', hours: '2:00 PM - 10:00 PM' },
        { day: 'Wednesday', day_short: 'WE', hours: '9:00 AM - 5:00 PM' },
        { day: 'Thursday', day_short: 'TH', hours: '2:00 PM - 10:00 PM' },
        { day: 'Friday', day_short: 'FR', hours: '9:00 AM - 5:00 PM' },
        { day: 'Saturday', day_short: 'SA', hours: 'By Appointment' },
        { day: 'Sunday', day_short: 'SU', hours: 'Closed' },
    ]
}
export default officeInfo;